import React, { useRef, useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';
import clsx from 'clsx';

import { useMediaQuery } from '@material-ui/core';
// import { useTheme } from '@material-ui/core/styles';
import { breakpoints } from '../../../../styles/themes/vad/constants';
import { COMPONENT_NAME, LOCATION, SOCIAL_ICONS } from './locators';

import { Text } from '@sitecore-jss/sitecore-jss-react';

import Grid from '../../../components/molecules/Grid';
import StickyBar from '../../../components/atoms/StickyBar';
import Box from '../../../components/molecules/Box';
import Link from '../../../components/atoms/Link';
import Button from '../../../components/atoms/Button';
import Typography from '../../../components/atoms/Typography';
import DctSvgIcon from '../../../components/atoms/Svg';
import Rating from '../../../components/atoms/Rating';
import Overlay from '../../../components/atoms/Overlay';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { analyticsData } from '../../../../../src/constants/Analytics/analytics-data';
import smoothScrollTo from '../../../utils/Polyfill/smoothScrollTo';

import useStyles from './style';
import {
  EVENT_LIST_TEMPLATE_NAME,
  ITINERARY_LIST_TEMPLATE_NAME,
} from './constants';
import {
  EVENTS_THEME_COLOR,
  LISTING_THEME_COLOR,
  EVENT_TYPE,
  TICKET_COMPONENT_ID,
  TICKETED_EVENT_TEXT,
} from '../../../../constants';
import {
  pushAnaylyticsData,
  createDynamicLabels,
} from '../../../../utils/analytics';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';
import { canUseDOM } from '../../../utils/canUseDOM';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { validateUrl } from '../../../../utils/utility';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { FAQ_TEMPLATE_ID, EVENT_DETAILS_TEMPLATE_ID, DETAILS_TEMPLATE_IDS_ARRAY } from '../../../../constants/index';
import Favorite from '../../../components/atoms/Favorite';

// #TODO: Needs to check export.
export const StickyTitle = props => {
  const { sitecoreContext, t: dictionary } = props;
  const {
    name,
    email,
    rating,
    instagramUrl,
    facebookUrl,
    twitterUrl,
    websiteUrl,
    youtubeUrl,
    phoneNumber,
    primaryCTAs: primaryCTA,
    location,
    isPaid,
  } = get(sitecoreContext, 'route.fields', '');
  let eventType = '';
  if (
    isPaid &&
    isPaid.value &&
    (isPaid.value === 'true' || isPaid.value === true)
  ) {
    eventType = TICKETED_EVENT_TEXT;
  }
  const contentType = get(
    sitecoreContext,
    'route.fields.contentType.fields.taxonomyKey.value',
    ''
  ).toLowerCase();
  const pageName = getPageName(props);
  const componentName = getComponentName(props);
  const siteCoreRoute = get(props, 'sitecoreContext.route', {});
  const templateId = get(siteCoreRoute, 'templateId', '');

  const itemUniqueKey = templateId === EVENT_DETAILS_TEMPLATE_ID ?
    get(siteCoreRoute, 'fields.eventId.value', '') :
    get(siteCoreRoute, 'itemId', '').replace(/-/g, '');

  const [hasFavouriteBasket, setHasFavouriteBasket] = useState(false);
  const vadHeader = get(
    props,
    'sitecoreContext.VADStaticRoute.sitecore.route.placeholders.vad-header',
    []
  );

  useEffect(() => {
    const favouriteBasket = vadHeader.find(
      item => item.componentName === 'FavoriteBasket'
    );
    const favIsActive = get(
      favouriteBasket,
      'fields["Is Active"].value',
      false
    );

    const isDetailsTemplateId = DETAILS_TEMPLATE_IDS_ARRAY.indexOf(templateId) > -1;
    setHasFavouriteBasket(Boolean(favouriteBasket) && favIsActive && isDetailsTemplateId);
  }, [vadHeader]);

  // const ratingOutOf = dictionary('outOf5');
  const stickyViewDetail = (dictionary && dictionary('stickyViewDetail')) || '';
  const primaryTextFromDictionary =
    (dictionary && dictionary('bookNowText')) || '';
  const secondaryCTA = {
    value: {
      text: stickyViewDetail,
    },
  };
  const emailValue =
    get(email, 'value.text', '') || getDictionaryText('emailCTA');
  const phoneNumValue = get(phoneNumber, 'value', '');
  const urlValue =
    get(websiteUrl, 'value.text', '') || getDictionaryText('websiteCTA');
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.md}px)`);
  // This comments for Event page
  const themeColor =
    contentType === EVENT_LIST_TEMPLATE_NAME
      ? EVENTS_THEME_COLOR
      : LISTING_THEME_COLOR;
  const isIternaryListingPage = contentType === ITINERARY_LIST_TEMPLATE_NAME;
  const classes = useStyles({ themeColor });

  const secTitleRef = useRef(null);
  const beforeStickyBarRef = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    setTimeout(() => {
      if (!isMobile && secTitleRef && secTitleRef.current && beforeStickyBarRef && beforeStickyBarRef.current) {
        let haveAnimatedOnce = false;
        gsap.timeline({
          scrollTrigger: {
            trigger: beforeStickyBarRef.current,
            start: 'top bottom',
            end: `+=${window.innerHeight * 0.2}px bottom`,
            scrub: true,
            once: true,
            onUpdate: self => {
              if (self.progress > 0.5) {
                secTitleRef && secTitleRef.current.animPlay();
                haveAnimatedOnce = true;
              } else if (haveAnimatedOnce) {
                secTitleRef && secTitleRef.current.animReverse();
              }
            },
          },
        });
      }
    }, 100);
  });

  const renderSocialMediaIcons = () => {
    // Making youtube's url as other social links.
    if (youtubeUrl && youtubeUrl.value && !youtubeUrl.value.href) {
      youtubeUrl.value = {
        href: youtubeUrl.value,
        linktype: 'external',
        target: '_blank',
      };
    }
    const arr = [
      { link: twitterUrl, iconName: 'TwitterIcon', iconText: 'Twitter' },
      { link: instagramUrl, iconName: 'InstagramIcon', iconText: 'Instagram' },
      { link: facebookUrl, iconName: 'FacebookIcon', iconText: 'Facebook' },
      { link: youtubeUrl, iconName: 'YouTubeIcon', iconText: 'YouTube' },
    ];
    return arr.map((icon, i) => {
      if (get(icon, 'link.value.href') && validateUrl(get(icon, 'link.value.href'))) {
        return (
          <Link
            field={icon.link}
            key={i}
            data-id={get(analyticsData, 'dataIds.pageBodyNavLinkClick')}
            title={icon.iconText}
            data-link={createDynamicLabels([
              pageName,
              componentName,
              `${get(analyticsData, 'dataLinksText.socialShare')}-${icon.iconName
              }`,
            ])}
          >
            <Button
              iconOnly={true}
              component="span"
              srText={icon.iconName}
              className={clsx({
                facebookIcon: icon.iconName === 'FacebookIcon',
              })}
              tabIndex="-1"
            >
              <DctSvgIcon name={icon.iconName} />
            </Button>
          </Link>
        );
      }
      return null;
    });
  };

  const nativeSmoothScrollTo = elem => {
    setTimeout(function () {
      window.scrollTo({
        top: elem.offsetTop - window.innerHeight / 2 + 200,
        left: 0,
        behavior: 'smooth',
      });
    }, 100);
  };

  const addStickyBtnAnalytics = ctaTextForAnalytics => {
    if (contentType === EVENT_TYPE && canUseDOM) {
      document.querySelector('.overlayCloseBtn') &&
        document.querySelector('.overlayCloseBtn').click();
      let ticketComponentDom = document.getElementById(TICKET_COMPONENT_ID);
      if (ticketComponentDom) {
        // detect support for the behavior property in ScrollOptions
        const supportsNativeSmoothScroll =
          'scrollBehavior' in document.documentElement.style;
        if (supportsNativeSmoothScroll) {
          nativeSmoothScrollTo(ticketComponentDom);
        } else {
          smoothScrollTo(
            ticketComponentDom.offsetTop - window.innerHeight / 2 + 200,
            700
          );
        }
      }
    }

    const obj = {
      ...get(analyticsData, 'pageBodyInteraction.primaryCTAClick'),
      ...{
        action: createDynamicLabels([
          pageName,
          componentName,
          ctaTextForAnalytics,
        ]),
      },
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          name && name.value,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };

  const renderPrimaryCTA = () => {
    let btnText = get(primaryCTA, 'value.text', '');
    let primaryCTAField = { ...primaryCTA };
    if (contentType === EVENT_TYPE) {
      btnText = primaryTextFromDictionary;
      primaryCTAField = { value: { text: btnText } };
    }
    return btnText ? (
      <div className={classes.dflex}>
        {isMobile && <div className={classes.vdiv}></div>}

        <Button
          field={primaryCTAField}
          type="button"
          buttonType="form"
          size="small"
          hasBorder={false}
          onClick={e => {
            if (contentType === EVENT_TYPE) {
              e.preventDefault();
            }
            addStickyBtnAnalytics(btnText);
          }}
          // This comments for Event page
          themeColor={
            contentType === EVENT_LIST_TEMPLATE_NAME ? EVENTS_THEME_COLOR : ''
          }
        >
          <Typography
            variant="subtitle2"
            component="span"
            color="inherit"
            className="primaryCTA"
          >
            <Text field={{ value: btnText }} />
          </Typography>
        </Button>
      </div>
    ) : null;
  };

  const renderFavoriteIconSection = (isDetailPresent) => {
    return (
      <>{hasFavouriteBasket &&
        <Favorite
          ariaLabel={name.value}
          itemUniqueKey={itemUniqueKey}
          componentName={componentName}
          dictionary={dictionary}
          contentType={contentType}
          isDetailPresent={isDetailPresent}
        />
      }
      </>
    )
  }

  const renderCTASection = () => {
    return (
      <Box className={`cta-wrap ${classes.ctaWrapper}`}>
        {stickyViewDetail && isDetailPresent && (
          <Overlay
            primaryCTA={secondaryCTA}
            buttonProps={{
              hasBorder: false,
              size: 'small',
              buttonType: 'secondary',
              className: 'secondaryCTA',
            }}
            className={classes.modalPopUp}
            from="StickyTitle"
            node={
              renderFavoriteIconSection()
            }
          >
            {renderCommonLayout()}
          </Overlay>
        )}
        {(contentType === EVENT_TYPE
          ? eventType === TICKETED_EVENT_TEXT
          : getPrimaryCTAValue()) && renderPrimaryCTA()}
      </Box>
    );
  };
  const addWebsiteClickAnaltics = () => {
    const obj = {
      ...get(analyticsData, 'pageBodyInteraction.visitWebsiteClick'),
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          name && name.value,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };
  const isDetailPresent = emailValue || phoneNumValue || urlValue;
  const hasDetails = email?.value?.href || phoneNumValue || websiteUrl?.value?.href;
  const socialIcons = renderSocialMediaIcons().filter(item => item !== null);
  const btnText = get(primaryCTA, 'value.text', '');

  /* Get sitecore context & extract ticketsDataLength */
  // from sitecoreContext.route.placeholders.vad-main array get object with componentName="tickets"
  const vadMain = get(
    sitecoreContext,
    'route.placeholders.vad-main',
    []
  );
  // get object with componentName="tickets" from ticketsData
  const ticketsData = get(
    vadMain,
    vadMain.findIndex(item => item.componentName === 'Tickets'),
    0
  );
  // Get ticketsData Length
  const ticketsWithUrls = ticketsData && ticketsData.fields &&
    ticketsData.fields.ticket && ticketsData.fields.ticket.filter(item => item?.field?.ticketWebUrl?.value)
  const ticketsDataLength = ticketsWithUrls && ticketsWithUrls.length

  const getPrimaryCTAValue = () => {
    const value = primaryCTA && primaryCTA.value;
    if (!value) {
      return false;
    }
    const { href, linktype } = value;
    return value && href && linktype !== 'mailto' ? href !== ('http://' || 'https://') : href
  }

  const renderCommonLayout = () => {
    return (
      <React.Fragment>
        {name && (
          <Typography
            variant="h2"
            component="h1"
            className={`page-title ${isMobile && 'sticky-hidden'} ${classes.pageTitle
              }`}
            ref={secTitleRef}
            title={name.value}
            wordBreak
            animateSettings={{
              selfTriggerMobOnly: true,
              willAnimate: true,
            }}
          >
            <span>
              <Text field={name} />
            </span>
            {rating && <Rating rating={rating.value} className="rating" />}
          </Typography>
        )}
        {location && !isIternaryListingPage && (
          <Typography
            variant="body2"
            component="p"
            className={`sticky-hidden ${classes.location}`}
            data-locator={LOCATION}
          >
            <Text field={location} />
          </Typography>
        )}
        {(isDetailPresent || socialIcons.length > 0 || btnText) && (
          <Grid
            container
            className={`detail-section ${classes.detailSection} ${btnText &&
              'btn-present'}`}
          >
            {isDetailPresent && (
              <Box
                className={clsx('contacts-section', classes.contacts, {
                  'sticky-hidden': isMobile,
                  'hideFavText': hasDetails || socialIcons.length > 0 || btnText,
                })
                }
              >

                {renderFavoriteIconSection('contacts-section')}

                {hasDetails && <div className={clsx(classes.verticalBar,
                  {
                    'ml4': hasDetails || socialIcons.length > 0 || btnText,
                  })}></div>}

                {emailValue && email?.value?.href && (
                  <Link
                    link={email}
                    className={classes.contactTxt}
                    data-id={get(
                      analyticsData,
                      'dataIds.pageBodyNavLinkClick',
                      ''
                    )}
                    data-link={createDynamicLabels([
                      pageName,
                      componentName,
                      get(analyticsData, 'dataLinksText.contactByEmail'),
                    ])}
                  >
                    <Typography
                      variant="body2"
                      component="span"
                      color="inherit"
                    >
                      <Text field={{ value: emailValue }} />
                    </Typography>
                  </Link>
                )}
                {phoneNumValue && (
                  <Link
                    link={{
                      value: {
                        href: `tel:${phoneNumValue}`,
                        text: phoneNumValue,
                      },
                    }}
                    data-id={get(analyticsData, 'dataIds.pageBodyNavLinkClick')}
                    data-link={createDynamicLabels([
                      pageName,
                      componentName,
                      get(analyticsData, 'dataLinksText.contactByPhone'),
                    ])}
                    className={`${classes.contactTxt} no-flip`}
                  >
                    <Typography
                      variant="body2"
                      component="span"
                      color="inherit"
                    >
                      <Text field={phoneNumber} />
                    </Typography>
                  </Link>
                )}
                {urlValue && websiteUrl?.value?.href && (
                  <Link
                    link={websiteUrl}
                    onClick={addWebsiteClickAnaltics}
                    className={classes.contactTxt}
                  >
                    <Typography
                      variant="body2"
                      component="span"
                      color="inherit"
                    >
                      <Text field={{ value: urlValue }} />
                    </Typography>
                  </Link>
                )}
              </Box>
            )}
            {socialIcons.length > 0 && (
              <Box
                className={clsx('sticky-hidden', classes.socialIcons)}
                mb={{ xs: 3, lg: 0 }}
                data-locator={SOCIAL_ICONS}
              >
                <div className={`${classes.verticalBar} ${classes.ml30}`}></div>
                {socialIcons}
              </Box>
            )}
            {(contentType === EVENT_TYPE && ticketsDataLength
              ? eventType === TICKETED_EVENT_TEXT
              : getPrimaryCTAValue()) && (
                <Box
                  className={clsx(
                    {
                      'mobile-cta-wrap': isMobile,
                    },
                    classes.ctaWrapper
                  )}
                >
                  <div className={`${classes.verticalBar} ${classes.ml30}`}></div>
                  {renderPrimaryCTA()}
                </Box>
              )}
          </Grid>
        )}
      </React.Fragment>
    );
  };
  return (
    <>
      <div ref={beforeStickyBarRef} />
      <StickyBar>
        <Grid data-locator={COMPONENT_NAME}>
          <Grid container direction="column" className="section-container">
            {renderCommonLayout()}
            {isMobile &&
              templateId !== FAQ_TEMPLATE_ID &&
              (isDetailPresent || socialIcons.length > 0 || btnText) &&
              renderCTASection()}
          </Grid>
        </Grid>
      </StickyBar>
      <div id="ghostDiv"></div>
    </>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(StickyTitle))
);


